import { Box, FormLabel, Text } from '@chakra-ui/react';

import ExistingNumbersTable from '../../../existingNumbers/ExistingNumbersTable';
import {
    formLabelStyling,
    descriptionStyling,
    numbersToPortStyle,
} from 'components/forms/new/formStyles';

const NumbersToPort = ({ setState, darkMode }) => {
    return (
        <Box sx={numbersToPortStyle}>
            <FormLabel
                sx={{
                    ...formLabelStyling(darkMode),
                    paddingTop: '15px',
                    display: 'flex',
                }}>
                <Text width={190}>Numbers To Port</Text>
                <Box
                    sx={{
                        ...descriptionStyling,
                        lineHeight: '19.2px',
                        fontSize: '12px',
                        pl: '8px',
                    }}
                    maxWidth={250}>
                    <p>
                        To quickly add multiple numbers to port, copy and paste
                        a line separated list of number ranges
                    </p>
                    <p>
                        into the <b>From</b> field below
                    </p>
                </Box>
            </FormLabel>
            <ExistingNumbersTable setState={setState} />
        </Box>
    );
};

export default NumbersToPort;
